import React, { useRef } from "react";
import { useDrag, useDrop } from "react-dnd";
import File from "./File";

const MoveableFile = ({ file, index, moveFile, removeFile, fileFormats }) => {
  const ref = useRef(null);

  const [, drop] = useDrop({
    accept: fileFormats,
    hover(item) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) {
        return;
      }
      moveFile(dragIndex, hoverIndex);
      item.index = hoverIndex;
    }
  });

  const [{ isDragging }, drag] = useDrag({
    item: { id: file.id, index },
    type: fileFormats,
    collect: monitor => ({
      isDragging: monitor.isDragging()
    })
  });

  drag(drop(ref));

  return (
    <div key={file.filename} className="col-md-3" ref={ref} style={{ opacity: isDragging ? 0 : 1 }}>
      <File file={file} removeFile={removeFile}/>
    </div>
  );
};

export default MoveableFile;